"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _url = require("url");
var _classnames = _interopRequireDefault(require("classnames"));
var _debug = _interopRequireDefault(require("debug"));
var _react = _interopRequireDefault(require("react"));
var _Spinner = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Spinner"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var eventHandlerUtils = _interopRequireWildcard(require("../../utils/eventHandlers"));
var _Icon2 = _interopRequireDefault(require("./Icon"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t3 in e) "default" !== _t3 && {}.hasOwnProperty.call(e, _t3) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t3)) && (i.get || i.set) ? o(f, _t3, i) : f[_t3] = e[_t3]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var CloseIcon = function CloseIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.293 4.293a1 1 0 0 1 1.414 0L12 10.586l6.293-6.293a1 1 0 1 1 1.414 1.414L13.414 12l6.293 6.293a1 1 0 0 1-1.414 1.414L12 13.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L10.586 12 4.293 5.707a1 1 0 0 1 0-1.414z"
  }));
};
CloseIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var EditIcon = function EditIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.728 2.88a3.013 3.013 0 0 1 4.257 0l2.133 2.13a3.005 3.005 0 0 1 0 4.254l-2.412 2.406-9.186 9.172a1 1 0 0 1-.526.276l-4.626.849a2.005 2.005 0 0 1-2.34-2.301l.77-4.613a1 1 0 0 1 .28-.543l9.239-9.223 2.41-2.407zM18 9.55l1.704-1.701a1.005 1.005 0 0 0 0-1.424l-2.132-2.13a1.014 1.014 0 0 0-1.431 0l-1.702 1.7L18 9.55zm-4.977-2.143L4.718 15.7 4 19.995v.002h.001l.003.003h.003l4.32-.793 8.258-8.244-3.562-3.556z"
  }));
};
EditIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "upload-wrapper": "upload-wrapper_2ymnwZ",
  "uploadWrapper": "upload-wrapper_2ymnwZ",
  "spinner": "spinner_1S9hWE",
  "upload-icon": "upload-icon_1EpVTn",
  "uploadIcon": "upload-icon_1EpVTn",
  "delete-icon": "delete-icon_2TFy61",
  "deleteIcon": "delete-icon_2TFy61",
  "image-container": "image-container_q7nB-x",
  "imageContainer": "image-container_q7nB-x",
  "certified": "certified_3yIoBm",
  "image": "image_DF5m0i",
  "sm": "sm_1146J2",
  "md": "md_2NgV2k",
  "lg": "lg_fgUmYC"
}; 
require('./AssetImage.css');
var log = (0, _debug.default)('exchange:AssetImage:component');
var AssetImage = /*#__PURE__*/function (_React$Component) {
  function AssetImage() {
    var _this;
    (0, _classCallCheck2.default)(this, AssetImage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AssetImage, [].concat(args));
    (0, _defineProperty2.default)(_this, "uploadInput", void 0);
    (0, _defineProperty2.default)(_this, "state", {
      showUploadSpinner: false
    });
    (0, _defineProperty2.default)(_this, "handleIconSave", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator().m(function _callee(event) {
        var onSaveIcon, iconFile, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              onSaveIcon = _this.props.onSaveIcon;
              iconFile = event.target.files[0];
              log('Saving icon', iconFile);
              _this.setState({
                showUploadSpinner: true
              });
              _context.p = 1;
              _context.n = 2;
              return onSaveIcon(iconFile);
            case 2:
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              log('Saving has failed', _t);
              _this.setState({
                showUploadSpinner: false
              });
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)(_this, "handleIconDelete", /*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator().m(function _callee2() {
      var onDeleteIcon, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            onDeleteIcon = _this.props.onDeleteIcon;
            log('Deleting icon');
            _this.setState({
              showUploadSpinner: true
            });
            _context2.p = 1;
            _context2.n = 2;
            return onDeleteIcon();
          case 2:
            _this.setState({
              showUploadSpinner: false
            });
            _context2.n = 4;
            break;
          case 3:
            _context2.p = 3;
            _t2 = _context2.v;
            log('Deletion has failed', _t2);
            _this.setState({
              showUploadSpinner: false
            });
          case 4:
            return _context2.a(2);
        }
      }, _callee2, null, [[1, 3]]);
    })));
    (0, _defineProperty2.default)(_this, "handleImageLoad", function () {
      _this.setState({
        showUploadSpinner: false
      });
    });
    (0, _defineProperty2.default)(_this, "getBorderColor", function () {
      var assetTypesConfiguration = _this.context;
      var type = _this.props.type;
      if (assetTypesConfiguration[type]) {
        return assetTypesConfiguration[type].color;
      }
      return assetTypesConfiguration.default.color;
    });
    return _this;
  }
  (0, _inherits2.default)(AssetImage, _React$Component);
  return (0, _createClass2.default)(AssetImage, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        alt = _this$props.alt,
        size = _this$props.size,
        isCertified = _this$props.isCertified,
        isEditable = _this$props.isEditable,
        icon = _this$props.icon,
        ariaHidden = _this$props.ariaHidden,
        type = _this$props.type,
        onLoadError = _this$props.onLoadError;
      var displayDeleteButton = !this.state.showUploadSpinner && !!icon;
      var displayUploadButton = !this.state.showUploadSpinner && !icon;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: styles.imageContainer,
        "aria-hidden": ariaHidden
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(styles.image, styles[size]),
        style: {
          borderColor: this.getBorderColor()
        }
      }, /*#__PURE__*/_react.default.createElement(_Icon2.default, {
        alt: alt,
        icon: icon,
        key: icon,
        size: size,
        onError: onLoadError,
        onLoad: this.handleImageLoad,
        type: type
      })), isCertified ? /*#__PURE__*/_react.default.createElement(_exchangeReactHooks.ConfigContext.Consumer, null, function (config) {
        return /*#__PURE__*/_react.default.createElement("img", {
          "data-test-id": "asset-is-certified",
          className: styles.certified,
          alt: "Mulesoft certified badge",
          loading: "lazy",
          src: (0, _url.format)(_objectSpread(_objectSpread({}, config.images.uri), {}, {
            pathname: 'certified.png'
          }))
        });
      }) : null, isEditable ? /*#__PURE__*/_react.default.createElement("div", {
        "data-test-id": "asset-is-editable",
        className: styles.uploadWrapper
      }, displayUploadButton ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
        "data-test-id": "edit-asset-icon" // this value should not be changed because it is used in AppCues
        ,
        role: "button",
        "aria-label": "Upload icon",
        size: "xs",
        className: styles.uploadIcon,
        tabIndex: "0",
        onClick: function onClick() {
          return _this2.uploadInput.click();
        },
        onKeyDown: eventHandlerUtils.onEnterKey(function () {
          return _this2.uploadInput.click();
        })
      }, /*#__PURE__*/_react.default.createElement(EditIcon, null)) : null, this.state.showUploadSpinner ? /*#__PURE__*/_react.default.createElement(_Spinner.default, {
        className: styles.spinner,
        size: "s",
        "data-test-id": "asset-image-spinner"
      }) : null, displayUploadButton ? /*#__PURE__*/_react.default.createElement("input", {
        type: "file",
        onChange: this.handleIconSave,
        ref: function ref(uploadInput) {
          _this2.uploadInput = uploadInput;
        },
        accept: "image/png, image/jpeg, image/svg+xml"
      }) : null, displayDeleteButton ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
        "data-test-id": "asset-icon-delete",
        role: "button",
        "aria-label": "Delete icon",
        size: "xs",
        className: styles.deleteIcon,
        onClick: this.handleIconDelete,
        tabIndex: "0",
        onKeyDown: eventHandlerUtils.onEnterKey(this.handleIconDelete)
      }, /*#__PURE__*/_react.default.createElement(CloseIcon, null)) : null) : null);
    }
  }]);
}(_react.default.Component);
(0, _defineProperty2.default)(AssetImage, "contextType", _exchangeReactHooks.AssetTypesConfigurationContext);
(0, _defineProperty2.default)(AssetImage, "defaultProps", {
  size: 'md',
  isCertified: false,
  ariaHidden: false,
  isEditable: false,
  onDeleteIcon: function onDeleteIcon() {},
  onSaveIcon: function onSaveIcon() {},
  onLoadError: function onLoadError() {}
});
var _default = exports.default = AssetImage;
//# sourceMappingURL=AssetImage.js.map